
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Contacts.css';

const Contacts = () => (
  <div className="breadcrumbs">

    <Helmet>
      <title>Контакты Сергея Мавроди - Официальный сайт</title>
      <meta
        name="description"
        content="Свяжитесь с Сергеем Мавроди через email или зеркала сайта."
      />
      <meta name="keywords" content="Сергей Мавроди, МММ, контакты, email" />
      <meta name="author" content="Сергей Мавроди" />
      <meta property="og:title" content="Контакты Сергея Мавроди" />
      <meta
        property="og:description"
        content="Свяжитесь с нами через email. Официальный сайт Сергея Мавроди."
      />
      <meta property="og:image" content="https://sergey-mavrodi.com/portrait.webp" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content="https://sergey-mavrodi.com/contacts" />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ru_RU" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Контакты Сергея Мавроди" />
      <meta name="twitter:description" content="Свяжитесь с нами через email." />
      <meta name="twitter:image" content="https://sergey-mavrodi.com/portrait.webp" />
      <link rel="canonical" href="https://sergey-mavrodi.com/contacts" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': 'Контакты Сергея Мавроди',
          'description': 'Свяжитесь с Сергеем Мавроди через email.',
          'url': 'https://sergey-mavrodi.com/contacts',
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Главная',
                'item': 'https://sergey-mavrodi.com/',
              },
              {
                '@type': 'ListItem',
                'position': 2,
                'name': 'Контакты',
                'item': 'https://sergey-mavrodi.com/contacts',
              },
            ],
          },
          'mainEntity': {
            '@type': 'Organization',
            'name': 'Сергей Мавроди',
            'url': 'https://sergey-mavrodi.com',
            'address': { '@type': 'PostalAddress', 'addressLocality': 'Москва', 'addressCountry': 'RU' },
            'email': 'mmm-2011@sergey-mavrodi.com',
            'contactPoint': [
              { '@type': 'ContactPoint', 'email': 'mmm-2011@sergey-mavrodi.com', 'contactType': 'customer support' },
              { '@type': 'ContactPoint', 'email': 'theatermavrodi@gmail.com', 'contactType': 'administrator' },
              { '@type': 'ContactPoint', 'email': 'system@sergey-mavrodi.com', 'contactType': 'technical support' },
            ],
            'sameAs': [
              'https://vk.com/theatermavrodi',
              'https://facebook.com/profile.php?id=100056900434020',
              'https://youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg',
              'https://rutube.ru/channel/39271788/',
            ],
          },
        })}
      </script>
    </Helmet>
    
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → Контакты
      </div>

    <div className="content">
      <div className="content_white_cloud">
        <div className="cwc_top"></div>
        <div className="cwc_mid">
          <div className="content">
            <h2>КОНТАКТЫ</h2>
            <hr/>
            <div className="card-container">
    <div className="card">
      <h3 className="card-title">
        СЕРГЕЙ МАВРОДИ
      </h3>
      <table className="card-table">
        <tbody>

          <tr>
            <td>
              Официальный сайт:&nbsp;
              <a
                href="https://sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Зеркала:&nbsp;  
              <a
                href="https://sergey-mavrodi.ms"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '17px', textDecoration: 'none' }}
              >
                sergey-mavrodi.ms
              </a>&nbsp;/&nbsp;  
              <a
                href="https://mavrodi-mmm-2011.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '17px', textDecoration: 'none' }}
              >
                mavrodi-mmm-2011.com
              </a>   
            </td>
          </tr>
          
          <tr>
            <td>
              Почта:&nbsp;  
              <a
                href="mailto:mmm-2011@sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                mmm-2011@sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Администратор:&nbsp;  
              <a
                href="mailto:theatermavrodi@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                theatermavrodi@gmail.com
              </a>
            </td>
          </tr>
          <tr>
            <td>
              Личный кабинет:&nbsp;  
              <a
                href="mailto:system@sergey-mavrodi.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'rgb(0, 0, 255)', fontSize: '20px', textDecoration: 'none' }}
              >
                system@sergey-mavrodi.com
              </a>
            </td>
          </tr>
          <tr>
            <td className="card-note">
              P.S. И имейте в виду. Всё предварительно читает Администратор. <br/>Просто честно предупреждаю. Во избежание. :-))
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
          </div>
        </div>
        <div className="cwc_bot"></div>
      </div>
    </div>
  </div>
);

export default Contacts;
